import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import AdvoxPopupDispatcher from 'Store/AdvoxPopup/AdvoxPopup.dispatcher';
import BrowserDatabase from 'Util/BrowserDatabase';
import { ONE_MONTH_IN_SECONDS } from 'Util/Request/QueryDispatcher';

import AdvoxPopup from './AdvoxPopup.component';
import { ADVOX_POPUP_PREFIX } from './AdvoxPopup.config';

/** @namespace Pwa/Component/AdvoxPopup/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    getPopups: () => AdvoxPopupDispatcher.getAdvoxPopups(dispatch),
});

/** @namespace Pwa/Component/AdvoxPopup/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    popups: state.AdvoxPopupReducer.popups,
    isMobile: state.ConfigReducer.device.isMobile,
    isTablet: state.ConfigReducer.device.isTablet,
});

/** @namespace Pwa/Component/AdvoxPopup/Container */
export class AdvoxPopupContainer extends PureComponent {
    containerFunctions = {
        closePopupHandle: this.closePopupHandle.bind(this),
    };

    componentDidMount() {
        this.getPopupsList();
    }

    componentDidUpdate(prevProps) {
        const { isSignedIn } = this.props;
        const { isSignedIn: prevIsSignedIn } = prevProps;

        if (isSignedIn !== prevIsSignedIn) {
            this.getPopupsList();
        }
    }

    async getPopupsList() {
        const { getPopups } = this.props;

        await getPopups();
    }

    closePopupHandle(popupId) {
        const popupFullId = `${ADVOX_POPUP_PREFIX}_${popupId}`;
        BrowserDatabase.setItem(true, popupFullId, ONE_MONTH_IN_SECONDS);

        const popupDOM = document.getElementById(popupFullId);

        if (popupDOM) {
            popupDOM.style.display = 'none';
        }
    }

    containerProps() {
        return { ...this.props };
    }

    render() {
        return <AdvoxPopup {...this.containerProps()} {...this.containerFunctions} />;
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdvoxPopupContainer));
